'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Typography } from '@/components/ui/typography/typography.component';
import { CartItem } from '@/types/cart.types';
import {
  getCartItemPrice,
  hasCartItemCouponDiscount,
  hasCartItemDiscount,
  isPromotionalCartItem,
} from '@/utils/cart/get-cart-total.util';
import { currencyFormatter } from '@/utils/formatters/currency';

interface CartItemPriceProps {
  item: CartItem;
  priceDataTestId?: string;
}

export function CartItemPrice({ item, priceDataTestId }: CartItemPriceProps) {
  const hasDiscount = hasCartItemDiscount(item);
  const isCoupon = hasCartItemCouponDiscount(item);
  const isPromotional = isPromotionalCartItem(item);

  const discountColor = isCoupon ? 'text-success-700' : 'text-pink-700';
  const priceColor = hasDiscount || isPromotional ? discountColor : 'text-gray-700';
  const showsOriginalPrice = (hasDiscount || isPromotional) && (item.price ?? 0) > 0;

  return (
    <div className="flex flex-wrap items-center gap-1">
      <Typography
        className={`text-base font-bold leading-6 ${priceColor}`}
        data-testid={priceDataTestId ?? DataTestIdEnum.CART_ITEM_PRICE}
      >
        {currencyFormatter(getCartItemPrice(item))}
      </Typography>

      {showsOriginalPrice && (
        <Typography
          className="text-xs font-light leading-4 text-gray-700 line-through"
          data-testid={DataTestIdEnum.CART_ITEM_ORIGINAL_PRICE}
        >
          {currencyFormatter(item.price ?? 0)}
        </Typography>
      )}
    </div>
  );
}
